import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\CloseSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/CloseSupplierOrderController.php
* @route '/api/supplier-order/close/{supplier_order}'
*/
const CloseSupplierOrderController = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: CloseSupplierOrderController.url(args, options),
    method: 'put',
})

CloseSupplierOrderController.definition = {
    methods: ["put"],
    url: '/api/supplier-order/close/{supplier_order}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\SupplierOrder\CloseSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/CloseSupplierOrderController.php
* @route '/api/supplier-order/close/{supplier_order}'
*/
CloseSupplierOrderController.url = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: typeof args.supplier_order === 'object'
        ? args.supplier_order.id
        : args.supplier_order,
    }

    return CloseSupplierOrderController.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\CloseSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/CloseSupplierOrderController.php
* @route '/api/supplier-order/close/{supplier_order}'
*/
CloseSupplierOrderController.put = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: CloseSupplierOrderController.url(args, options),
    method: 'put',
})

export default CloseSupplierOrderController